/**
 * SearchSpring configuration utilities
 * Provides site ID and domain configuration for SearchSpring API requests
 */

import { globalState } from '@/components/helpers/utils'

export function getSearchSpringSiteID(category = 'products') {
  return globalState.siteIds[category]
}

export function getSearchSpringDomain(category) {
  switch (category) {
    case 'collections':
      return window.location.host + '/collections?view=ss-feed'
    case 'pages':
      return window.location.host + '/pages/faqs?view=ss-feed'
    case 'blogs':
      return window.location.host + '/blogs/fashion?view=ss-feed'
    case 'products':
    default:
      return window.location.href
  }
}
